<div class="modal-content-wrapper">
    <div class="principal-content" >
      <h4 class="mb-3" mat-dialog-title>Dependências</h4>
      <div class="overflow-visible" mat-dialog-content>
        <form id="dependency-form" [formGroup]="organizationWebFormGroup" (submit)="submit()">  
          <div class="container">
            <div class="row">
                <div class="col">
                    <span>Ambiente</span>
                    <ng-select class="mt-2" [clearable]="false" (change)="getOrganizationWebBuilds(organizationWebFormGroup.get('environment')?.value)" formControlName="environment">
                        <ng-option *ngFor="let environment of organizationWebDependency.environments" [value]="environment">
                            {{environment}}
                        </ng-option>               
                    </ng-select>
                </div>
            </div>  
            <div class="row mt-2">
                <div class="col">
                    <span>Versão</span>
                    <ng-select [loading]="loadingVersions()" [items]="versions()" formControlName="version" bindLabel="version" bindValue="version" [searchFn]="customSearchFn">
                        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="item">                    
                            <div style="margin: 10px 0;" class="card">
                                <div class="card-body">
                                    <h5 class="card-title" >{{item.version}}</h5>
                                    <h6 style="font-size: 0.9rem" class="card-subtitle mb-2 text-muted">{{item.author}}</h6>
                                    <p class="card-text build-message" *ngIf="item.pullRequestTitle">                                
                                        {{item.pullRequestTitle}}
                                    </p>                            
                                    <p class="card-text build-message" *ngIf="item.buildMessage">                                
                                        {{item.buildMessage}}
                                    </p>                            
                                </div>
                            </div>
                        </ng-template>
                    </ng-select> 
                </div>
            </div>    
          </div>   
        </form>
      </div>
  </div>

  <div  class="mt-3 d-flex align-items-center">
    <div>
      <button [disabled]="!organizationWebFormGroup.valid" form="dependency-form" type="submit" id="submitButton" class="btn btn-primary">Aplicar</button>
    </div>  
  </div>


